import { useReducer } from 'react'
import { v4 as uuidv4 } from 'uuid'

export const initialEvents = { events: [] }

const eventActionTypes = {
  clear: 'CLEAR',
  enqueue: 'ENQUEUE',
  dequeue: 'DEQUEUE',
}

export const eventReducer = (state, action) => {
  const { events } = state
  switch (action.type) {
    case eventActionTypes.clear:
      return {
        ...state,
        events: []
      }
    case eventActionTypes.enqueue: {
      const eventExists = events.some(event => event.id === action.payload.id)
      if (eventExists) {
        return state
      } else {
        events.push({ ...action.payload })
        return {
          ...state,
          events
        }
      }
    }
    case eventActionTypes.dequeue:
      return {
        ...state,
        events: events.slice(1)
      }
    default:
      return state
  }
}

const useEvent = () => {
  const [{ events }, dispatch] = useReducer(eventReducer, initialEvents)

  const clear = modalSettings => {
    dispatch({
      type: eventActionTypes.open,
      payload: modalSettings
    })
  }

  const enqueue = payload => {
    return dispatch({
      type: eventActionTypes.enqueue,
      payload: {
        id: uuidv4(),
        ...payload,
      }
    })
  }

  const dequeue = () => dispatch({ type: eventActionTypes.dequeue, payload: {} })

  return { events, clear, enqueue, dequeue }
}

export default useEvent
